import { useEffect, useState } from 'react';

const useTooltip = (items) => {
  const [tooltip, setTooltip] = useState(null);

  useEffect(() => {
    const description =
      items.length === 1
        ? 'Shareable link to video'
        : 'List of shareable links to videos';

    setTooltip({
      description,
      disableFocus: true,
    });
  }, [items]);

  return tooltip;
};

export default useTooltip;
